import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

/** Die Zone, in der das Portal Uhrzeiten zeigt — unabhängig von der Zone des Browsers. */
export const BERLIN = 'Europe/Berlin';

/**
 * Einen Zeitpunkt in deutscher Zeit formatieren. Ein Browser in US-Zeit zeigte 01:52 MESZ als
 * „16:52" (Retest 24.10.2026); der Prozessverlauf stand schon in deutscher Zeit, der Chat nicht.
 */
export const formatBerlin = (date: string | number | Date, pattern: string): string =>
    dayjs(date).tz(BERLIN).format(pattern);
